module.exports = __webpack_public_path__ + "img/72.05410f21.jpg";